import WideSecureLayout from "../../../../layout/WideSecureLayout.jsx";
import React from "react";
import {useLegacyPeriodReportState} from "./LegacyPeriodReportBoundary.jsx";
import DashboardGrid from "../../../../components/dashboard/DashboardGrid.jsx";
import OrderDashboardFilters from "./OrderDashboardFilters.jsx";

export default function OrderDashboardLayout({title, children, hideFilters, showMarketingFilters, showModeSwitch = true}) {
    const retention = useLegacyPeriodReportState();
    // noinspection JSValidateTypes
    return <WideSecureLayout periodReport={!hideFilters} retentionExpired={retention?.retentionExpired} title={title} actions={
        <OrderDashboardFilters
            hideFilters={hideFilters}
            showMarketingFilters={showMarketingFilters}
            showModeSwitch={showModeSwitch}
        />
    }>
        <DashboardGrid>
            {children}
        </DashboardGrid>
    </WideSecureLayout>;
}
